import {event, toggleClass} from "./functions";

event('.header__search', 'click', function (e) {
    toggleClass(document.querySelector('.search__form'), 'vis');
});
